<template>
  <div class="__range-input">
    <div class="input-box">
      <q-input ref="start" v-model="inputStart" label="From" dense @change="handleChange" />
    </div>
    <div class="separator">-</div>
    <div class="input-box">
      <q-input ref="end" v-model="inputEnd" label="To" dense @change="handleChange" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Mixin from './mixin';

export default {
  name: 'RangeInput',
  mixins: [Mixin],
  props: {
    range: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    minDate: {
      type: Date,
    },
    maxDate: {
      type: Date,
    },
    granularity: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      inputStart: '',
      inputEnd: '',

      invalidStart: false,
      invalidEnd: false,
    };
  },
  watch: {
    range: {
      handler: function(val) {
        this.inputStart = this.convertDate(val.start);
        this.inputEnd = this.convertDate(val.end);
      },
      deep: true,
    },

    inputStart() {
      this.invalidStart = false;
      this.resetValidation('start');
    },

    inputEnd() {
      this.invalidEnd = false;
      this.resetValidation('end');
    },
  },
  methods: {
    resetValidation(target) {
      this.$refs[target].resetValidation();
    },

    handleChange() {
      this.invalidStart = false;
      this.invalidEnd = false;

      const start = moment.utc(this.inputStart);
      const end = moment.utc(this.inputEnd);

      // Validate
      if (!moment(start).isSameOrBefore(end)) {
        this.invalidStart = true;
        // Set old value
        this.inputStart = this.convertDate(this.range.start);
      }

      if (!moment(end).isSameOrAfter(start)) {
        this.invalidEnd = true;
        // Set old value
        this.inputEnd = this.convertDate(this.range.end);
      }

      // API supports only 2 months daily data
      if (this.granularity === 'daily') {
        if (moment(end).diff(start, 'months', true) > 2) {
          this.invalidStart = true;
          this.invalidEnd = true;
          // Set old value
          this.inputStart = this.convertDate(this.range.start);
          this.inputEnd = this.convertDate(this.range.end);
        }
      }

      if (start < this.minDate) {
        this.invalidStart = true;
        // Set old value
        this.inputStart = this.convertDate(this.range.start);

        // Error Message
        // 〇〇以降の日付を指定してください。
      }

      if (end > this.maxDate) {
        this.invalidEnd = true;
        // Set old value
        this.inputEnd = this.convertDate(this.range.end);

        // Error Message
        // 〇〇以降の日付を指定してください。
      }

      if (!start._isValid) {
        this.invalidStart = true;
        // Set old value
        this.inputStart = this.convertDate(this.range.start);
      }

      if (!end._isValid) {
        this.invalidEnd = true;
        // Set old value
        this.inputEnd = this.convertDate(this.range.end);
      }

      if (this.invalidStart || this.invalidEnd) {
        return false;
      } else {
        this.$emit('change', { start: start._d, end: end._d });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.__range-input {
  display: flex;
  align-items: center;
  padding: 0 $padding-sm;
  margin-bottom: $margin-md;
}

.input-box {
  width: 100%;
}

.separator {
  font-size: $font-size-xl;
  padding: 0 $padding-lg;
}
</style>
